import { axiosInstanceWithCredentials } from "./base";

export function getSessionTimeouts(params) {
    return axiosInstanceWithCredentials.get("/sessiontimeouts", {
        params
    });
}

export function updateSessionTimeouts(data) {
    return axiosInstanceWithCredentials.put(`/sessiontimeout/`,data);
}

export function getServerLogs(params) {
    return axiosInstanceWithCredentials.get("/logs", {
        params
    });
}
